import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Edges from "../../Edges"

interface ITileContentBlockProps {
  headline: string
  subHeadline: string
  cards: Array<any>
}

export const TileContentBlock = ({
  headline = "",
  subHeadline = "",
  cards = [],
}: ITileContentBlockProps) => {
  return (
    cards && (
      <div className=" mb-[40px] bg-lightGrey pt-[60px] pb-[81px]">
        <Edges size="2xl">
          {headline && (
            <h2 className="mx-auto max-w-lg text-center text-darkBlue">
              {headline}
            </h2>
          )}
          {subHeadline && (
            <p className="mx-auto mt-1 text-center text-subTitle2 font-semibold text-mediumGrey">
              {subHeadline}
            </p>
          )}

          {cards && cards?.length > 0 && (
            <div className=" mt-[40px] flex flex-row flex-wrap justify-center lg:flex-nowrap">
              {cards.map(card => {
                const gatsbyImage1 =
                  card?.iconImage && getImage(card?.iconImage?.gatsbyImage)

                return (
                  <div
                    key={card.title}
                    className="mx-[15px] my-[15px] flex w-full max-w-[395px] flex-col items-center justify-center rounded bg-white mix-blend-normal shadow-[0_3px_13px_0px_rgba(0,0,0,0.16)] lg:my-[0px]"
                  >
                    {gatsbyImage1 && (
                      <div className="flex justify-center pt-[45px]">
                        <GatsbyImage
                          image={gatsbyImage1}
                          alt={card.iconImage.altText}
                        />
                      </div>
                    )}
                    {card?.heading && (
                      <h3 className="flex justify-center pt-[25px]  pb-2">
                        {card?.heading}
                      </h3>
                    )}
                    <div className="w-9/12 border-b-2	sm:w-8/12 " />

                    {card.title && (
                      <p className=" mt-[10px] text-body1 font-bold text-darkGrey">
                        {card.title}
                      </p>
                    )}
                    {card.text && (
                      <p className="text-darkGreyy mb-[30px] max-w-[225px] text-center text-body1">
                        {card.text}
                      </p>
                    )}

                    {card?.buttonGroup && card?.buttonGroup?.length > 0 && (
                      <div className="mt-auto flex  w-full justify-center rounded-b bg-darkBlue py-4">
                        {card.buttonGroup.map((button, idx) => (
                          <div className=" flex" key={idx}>
                            {button?.link?.url && (
                              <Link
                                to={button.link.url}
                                className={`${
                                  idx !== card?.buttonGroup?.length - 1 &&
                                  "border-r-2"
                                } SansProReg whitespace-nowrap px-[15px] text-linkButton text-yellow underline hover:no-underline `}
                              >
                                {button.link.title}
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </Edges>
      </div>
    )
  )
}

export default TileContentBlock
export const fragment = graphql`
  fragment TileContentBlock on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_TileContentBlock {
      fieldGroupName
      headline
      subHeadline
      cards {
        heading
        title
        text
        iconImage {
          altText
          gatsbyImage(
            quality: 90
            width: 72
            height: 72
            layout: CONSTRAINED
            formats: [AUTO, WEBP]
          )
        }

        buttonGroup {
          link {
            target
            title
            url
          }
        }
      }
    }
  }
`
